// utils
import { getColumnsFromStorage } from 'utils/localStorageHelper';
// config
import { getAvailColumns, getInitialColumnKeys } from './columnsConfig';

// Resolve persisted (or default) column keys for a table. Reconciles stored keys
// with the current config so columns added later show up by default instead of
// disappearing for users with an older saved layout.
export const getColumnsKeys = (tableName) => {
  const initialKeys = getInitialColumnKeys(tableName);
  const stored = getColumnsFromStorage(tableName);
  if (!stored) return initialKeys;

  const manageableIds = initialKeys.manageable;
  const visible = (stored.manageable || []).filter((id) => manageableIds.includes(id));
  const hidden = (stored.hidden || []).filter((id) => manageableIds.includes(id));
  const missing = manageableIds.filter((id) => !visible.includes(id) && !hidden.includes(id));

  return {
    fixed: initialKeys.fixed,
    manageable: [...visible, ...missing],
    hidden,
  };
};

// Map a keys-state to field descriptors for each section of the manage page.
export const buildColumnLists = (tableName, keys) => {
  const byId = getAvailColumns(tableName).reduce((acc, col) => ({ ...acc, [col.id]: col }), {});
  const pick = (ids) => ids.map((id) => byId[id]).filter(Boolean);
  return {
    fixed: pick(keys.fixed),
    manageable: pick(keys.manageable),
    hidden: pick(keys.hidden),
  };
};

// Apply persisted visibility/order to a table's column array before rendering.
// Columns without an `id` (action/arrow columns) keep their trailing position.
export const getOrderedColumns = (columns, tableName) => {
  const stored = getColumnsFromStorage(tableName);
  if (!stored) return columns;

  const { fixed, manageable } = getColumnsKeys(tableName);
  const byId = columns.reduce((acc, col) => (col.id ? { ...acc, [col.id]: col } : acc), {});
  const ordered = [...fixed, ...manageable].map((id) => byId[id]).filter(Boolean);
  const withoutId = columns.filter((col) => !col.id);

  return [...ordered, ...withoutId];
};

export const reorderList = (list, startIndex, endIndex) => {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const moveToOtherList = (source, destination, sourceIndex, destIndex) => {
  const src = [...source];
  const dest = [...destination];
  const [removed] = src.splice(sourceIndex, 1);
  dest.splice(destIndex, 0, removed);
  return [src, dest];
};
